import { types } from '../actions/AccordionActions';

export function addClipartModel (state, clipartModel) {
    return Object.assign({}, state, {
        clipartModel: clipartModel
    });
}

export function setAccordionActiveButton (state, buttonType) {
    return Object.assign({}, state, {
        accordionActiveButton: buttonType
    });
}

export function setMediaFilesDataProvider (state, dataProvider) {
    return Object.assign({}, state, {
        mediaFilesDataProvider: dataProvider
    });
}

export default function(state = {}, action) {

    switch (action.type) {
        case types.STATE_DRAW:
            return Object.assign({}, state, {drawState: action.state});

        case types.ADD_CLIPART_MODEL: {
            return addClipartModel(state, action.clipartModel);
        }

        case types.SET_ACCORDION_ACTIVE_BUTTON: {
            return setAccordionActiveButton(state, action.buttonType);
        }

        case types.SET_MEDIA_FILES_DATA_PROVIDER: {
            return setMediaFilesDataProvider(state, action.dataProvider);
        }

        case types.CHANGE_ACCORDION_WIDTH:
            return Object.assign({}, state, {width: action.width});

        case types.SET_ACTIVE_BUTTON:
            return Object.assign({}, state, {activeButton: action.value}, {isCollapsed: action.isCollapsed});

        case types.SET_OLD_ACTIVE_BUTTON:
            return Object.assign({}, state, {oldActiveButton: action.value});

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/AccordionReducer.js
 **/